import { SignedIn, SignedOut, useClerk, useUser } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/app/routes';

function Avatar({ src, name }: { src?: string; name: string }) {
  if (src) return <img src={src} alt={name} style={{ width: 34, height: 34, borderRadius: '50%', objectFit: 'cover' }} />;
  return (
    <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'var(--bg-2)', display: 'grid', placeItems: 'center', fontSize: 14, fontWeight: 700, color: 'var(--fg-60)' }}>
      {name ? name.charAt(0).toUpperCase() : 'P'}
    </div>
  );
}

// Ponto de sessão no header. Com sessão, o avatar navega para /conta
// (A minha conta) — rota real, deep-linkável. Sem sessão, botão Entrar (Clerk).
export function AuthControls() {
  const clerk = useClerk();
  const { user } = useUser();
  const navigate = useNavigate();

  return (
    <>
      <SignedOut>
        <button className="btn btn-gold btn-sm" onClick={() => clerk.openSignIn()}>Entrar</button>
      </SignedOut>
      <SignedIn>
        <button className="icon-btn" aria-label="A minha conta" onClick={() => navigate(ROUTES.conta)}
          style={{ padding: 0, background: 'transparent', border: 'none', width: 'auto', height: 'auto', outline: 'none', cursor: 'pointer' }}>
          <Avatar name={user?.firstName || 'Perfil'} src={user?.imageUrl} />
        </button>
      </SignedIn>
    </>
  );
}
